export const apiDocsZh = {
  toc: {
    title: '目录导航',
    smsApi: '短信发送API',
    errors: '错误码参考',
  },
  breadcrumb: {
    root: '开发对接',
    active: '对接文档',
  },
  smsApi: {
    title: '短信发送API',
    desc: '用于发送验证码、通知类短信及营销短信。支持单发和群发，群发时手机号以英文逗号分隔。',
    tabs: {
      verify: '验证码通知',
      marketing: '营销短信',
    },
    marketingNotice: '该接口与短信发送接口参数一致，用于发送营销类短信。营销短信需提前审核模板，未经审核的模板将无法发送。',
    sections: {
      requestParams: '请求参数',
      requestExample: '请求示例',
      responseExample: '响应示例',
      codeExample: '代码示例',
      failureExample: '失败响应示例',
      errorCodeList: '错误码列表',
      businessErrors: '常见业务错误',
    },
    tableHeaders: {
      paramName: '参数名',
      type: '类型',
      required: '必填',
      description: '说明',
      errorCode: '错误码',
      message: '说明',
      detail: '描述',
    },
    badges: {
      required: '必填',
      optional: '可选',
    },
    copy: '复制',
    copied: '已复制',
    codeTabs: {
      curl: 'cURL',
      js: 'JavaScript',
      python: 'Python',
    },
    exampleContent: {
      verify: '您的验证码是 123456',
      marketing: '限时优惠！全场5折起',
    },
    responseSuccess: '成功',
    responseParamError: '参数错误',
  },
  sendParams: {
    user: '用户名',
    secret: '用户密码',
    phone: '手机号码（多号码以逗号分隔）',
    context: '短信内容',
    senderId: '发送者ID（可选）',
  },
  callbackParams: {
    date: '回调时间',
    smsId: '短信ID',
    phone: '手机号码',
    index: '批次序号',
    status: '状态码（0=成功，其他=失败）',
  },
  errorCodes: {
    title: '错误码参考',
    desc: '接口返回的错误码及对应说明，帮助快速定位问题。',
    list: [
      { code: 200, message: '成功', description: '请求处理成功' },
      { code: 341, message: '余额不足', description: '账户余额不足，请及时充值' },
      { code: 342, message: '提交错误', description: '请求参数格式或内容错误' },
      { code: 400, message: '账户不存在', description: '提供的用户名或KEY无效' },
      { code: 403, message: '权限不足', description: '无权访问该接口或资源' },
      { code: 404, message: '参数错误', description: '缺少必填参数或参数格式不正确' },
      { code: 405, message: '格式异常', description: '请求体格式不符合要求' },
      { code: 418, message: '业务异常', description: '业务逻辑处理异常' },
      { code: 419, message: '发送异常', description: '短信发送过程中出现异常' },
      { code: 430, message: '签名错误', description: '请求签名验证失败' },
      { code: 500, message: '服务器错误', description: '服务端内部错误，请稍后重试' },
    ],
    business: [
      { code: 'BLACKLIST', message: '号码在黑名单中', description: '该手机号已被加入黑名单，无法发送' },
      { code: 'FREQUENCY_LIMIT', message: '发送频率限制', description: '同一号码发送过于频繁，请稍后再试' },
      { code: 'CONTENT_REJECT', message: '内容审核拒绝', description: '短信内容包含敏感词或违规内容' },
      { code: 'TEMPLATE_MISMATCH', message: '模板不匹配', description: '短信内容与审核通过的模板不匹配' },
      { code: 'AREA_RESTRICT', message: '区域限制', description: '目标号码所在区域暂不支持发送' },
    ],
  },
}

export const apiDocsEn = {
  toc: {
    title: 'Table of Contents',
    smsApi: 'SMS Send API',
    errors: 'Error Codes',
  },
  breadcrumb: {
    root: 'API Integration',
    active: 'API Documentation',
  },
  smsApi: {
    title: 'SMS Send API',
    desc: 'Send OTP, notification, and marketing messages. Supports single and bulk send — separate multiple numbers with commas.',
    tabs: {
      verify: 'OTP & Notifications',
      marketing: 'Marketing',
    },
    marketingNotice: 'Uses the same parameters as the SMS send API for marketing messages. Templates must be pre-approved; unapproved templates will be rejected.',
    sections: {
      requestParams: 'Request Parameters',
      requestExample: 'Request Example',
      responseExample: 'Response Example',
      codeExample: 'Code Example',
      failureExample: 'Failure Response Example',
      errorCodeList: 'Error Code List',
      businessErrors: 'Common Business Errors',
    },
    tableHeaders: {
      paramName: 'Parameter',
      type: 'Type',
      required: 'Required',
      description: 'Description',
      errorCode: 'Code',
      message: 'Message',
      detail: 'Description',
    },
    badges: {
      required: 'Required',
      optional: 'Optional',
    },
    copy: 'Copy',
    copied: 'Copied',
    codeTabs: {
      curl: 'cURL',
      js: 'JavaScript',
      python: 'Python',
    },
    exampleContent: {
      verify: 'Your verification code is 123456',
      marketing: 'Limited offer! Up to 50% off storewide',
    },
    responseSuccess: 'Success',
    responseParamError: 'Invalid parameters',
  },
  sendParams: {
    user: 'Username',
    secret: 'Password',
    phone: 'Phone number(s), comma-separated for bulk send',
    context: 'Message content',
    senderId: 'Sender ID (optional)',
  },
  callbackParams: {
    date: 'Callback time',
    smsId: 'SMS ID',
    phone: 'Phone number',
    index: 'Batch index',
    status: 'Status code (0=success, other=failed)',
  },
  errorCodes: {
    title: 'Error Code Reference',
    desc: 'API error codes and descriptions to help diagnose issues quickly.',
    list: [
      { code: 200, message: 'Success', description: 'Request processed successfully' },
      { code: 341, message: 'Insufficient balance', description: 'Account balance is too low. Please top up.' },
      { code: 342, message: 'Submit error', description: 'Invalid request parameter format or content' },
      { code: 400, message: 'Account not found', description: 'Invalid username or API key' },
      { code: 403, message: 'Permission denied', description: 'No access to this API or resource' },
      { code: 404, message: 'Invalid parameters', description: 'Missing required parameters or invalid format' },
      { code: 405, message: 'Format error', description: 'Request body format is invalid' },
      { code: 418, message: 'Business error', description: 'Business logic processing error' },
      { code: 419, message: 'Send error', description: 'An error occurred during message delivery' },
      { code: 430, message: 'Signature error', description: 'Request signature verification failed' },
      { code: 500, message: 'Server error', description: 'Internal server error. Please try again later.' },
    ],
    business: [
      { code: 'BLACKLIST', message: 'Number blacklisted', description: 'This phone number is blacklisted and cannot receive messages' },
      { code: 'FREQUENCY_LIMIT', message: 'Rate limit exceeded', description: 'Too many messages to the same number. Please try again later.' },
      { code: 'CONTENT_REJECT', message: 'Content rejected', description: 'Message contains sensitive or prohibited content' },
      { code: 'TEMPLATE_MISMATCH', message: 'Template mismatch', description: 'Message content does not match the approved template' },
      { code: 'AREA_RESTRICT', message: 'Area restricted', description: 'Sending to this region is not currently supported' },
    ],
  },
}

export const apiDocsJa = {
  toc: {
    title: '目次',
    smsApi: 'SMS送信API',
    errors: 'エラーコード',
  },
  breadcrumb: {
    root: 'API連携',
    active: 'APIドキュメント',
  },
  smsApi: {
    title: 'SMS送信API',
    desc: 'OTP・通知・マーケティングSMSの送信。単発・一括送信に対応。一括送信時は電話番号をカンマ区切りで指定。',
    tabs: {
      verify: 'OTP・通知',
      marketing: 'マーケティング',
    },
    marketingNotice: 'SMS送信APIと同じパラメータでマーケティングSMSを送信。テンプレートの事前審査が必要。未審査テンプレートは送信不可。',
    sections: {
      requestParams: 'リクエストパラメータ',
      requestExample: 'リクエスト例',
      responseExample: 'レスポンス例',
      codeExample: 'コード例',
      failureExample: '失敗レスポンス例',
      errorCodeList: 'エラーコード一覧',
      businessErrors: '一般的なビジネスエラー',
    },
    tableHeaders: {
      paramName: 'パラメータ',
      type: '型',
      required: '必須',
      description: '説明',
      errorCode: 'コード',
      message: 'メッセージ',
      detail: '説明',
    },
    badges: {
      required: '必須',
      optional: '任意',
    },
    copy: 'コピー',
    copied: 'コピー済み',
    codeTabs: {
      curl: 'cURL',
      js: 'JavaScript',
      python: 'Python',
    },
    exampleContent: {
      verify: '認証コードは 123456 です',
      marketing: '期間限定！全品50%OFF',
    },
    responseSuccess: '成功',
    responseParamError: 'パラメータエラー',
  },
  sendParams: {
    user: 'ユーザー名',
    secret: 'パスワード',
    phone: '電話番号（複数はカンマ区切り）',
    context: 'SMS内容',
    senderId: 'Sender ID（任意）',
  },
  callbackParams: {
    date: 'コールバック時間',
    smsId: 'SMS ID',
    phone: '電話番号',
    index: 'バッチ番号',
    status: 'ステータスコード（0=成功、その他=失敗）',
  },
  errorCodes: {
    title: 'エラーコード参考',
    desc: 'APIが返すエラーコードと説明。問題の特定に役立ちます。',
    list: [
      { code: 200, message: '成功', description: 'リクエストが正常に処理されました' },
      { code: 341, message: '残高不足', description: 'アカウント残高が不足しています。チャージしてください。' },
      { code: 342, message: '送信エラー', description: 'リクエストパラメータの形式または内容が不正です' },
      { code: 400, message: 'アカウント不存在', description: 'ユーザー名またはAPIキーが無効です' },
      { code: 403, message: '権限不足', description: 'このAPIまたはリソースへのアクセス権がありません' },
      { code: 404, message: 'パラメータエラー', description: '必須パラメータの欠落または形式が不正です' },
      { code: 405, message: '形式異常', description: 'リクエストボディの形式が不正です' },
      { code: 418, message: 'ビジネス異常', description: 'ビジネスロジック処理で異常が発生しました' },
      { code: 419, message: '送信異常', description: 'SMS送信中に異常が発生しました' },
      { code: 430, message: '署名エラー', description: 'リクエスト署名の検証に失敗しました' },
      { code: 500, message: 'サーバーエラー', description: 'サーバー内部エラー。後でもう一度お試しください。' },
    ],
    business: [
      { code: 'BLACKLIST', message: '番号がブラックリスト', description: 'この電話番号はブラックリストに登録されており送信できません' },
      { code: 'FREQUENCY_LIMIT', message: '送信頻度制限', description: '同一番号への送信が多すぎます。しばらくしてから再試行してください。' },
      { code: 'CONTENT_REJECT', message: 'コンテンツ審査拒否', description: 'SMS内容にセンシティブまたは禁止ワードが含まれています' },
      { code: 'TEMPLATE_MISMATCH', message: 'テンプレート不一致', description: 'SMS内容が審査済みテンプレートと一致しません' },
      { code: 'AREA_RESTRICT', message: '地域制限', description: '対象番号の地域では現在送信に対応していません' },
    ],
  },
}
